import { render, staticRenderFns } from "./shippingLable.vue?vue&type=template&id=0bbe6ace&scoped=true"
import script from "./shippingLable.vue?vue&type=script&lang=js"
export * from "./shippingLable.vue?vue&type=script&lang=js"
import style0 from "./shippingLable.vue?vue&type=style&index=0&id=0bbe6ace&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bbe6ace",
  null
  
)

export default component.exports